// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add margin to all table cells specifically within .tooldb__table */
.Table_tooldb__table__VoJZA {
    border-collapse: collapse;
  }
  
  .Table_tooldb__table__VoJZA th,
  .Table_tooldb__table__VoJZA td {
    border: 1px solid black;
    padding: 8px; /* Adjust the padding to control the space inside */
  }
  
  /* Define the hover effect for tool rows (except for the heading row) within .tooldb__table */
  .Table_tooldb__table__VoJZA tbody tr:hover {
    background-color: #f5f5f5; /* Change the background color to the desired shade */
    cursor: pointer;
  }
  `, "",{"version":3,"sources":["webpack://./src/tooldb/src/styles/Table.module.css"],"names":[],"mappings":"AAAA,qEAAqE;AACrE;IACI,yBAAyB;EAC3B;;EAEA;;IAEE,uBAAuB;IACvB,YAAY,EAAE,mDAAmD;EACnE;;EAEA,6FAA6F;EAC7F;IACE,yBAAyB,EAAE,qDAAqD;IAChF,eAAe;EACjB","sourcesContent":["/* Add margin to all table cells specifically within .tooldb__table */\n.tooldb__table {\n    border-collapse: collapse;\n  }\n  \n  .tooldb__table th,\n  .tooldb__table td {\n    border: 1px solid black;\n    padding: 8px; /* Adjust the padding to control the space inside */\n  }\n  \n  /* Define the hover effect for tool rows (except for the heading row) within .tooldb__table */\n  .tooldb__table tbody tr:hover {\n    background-color: #f5f5f5; /* Change the background color to the desired shade */\n    cursor: pointer;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooldb__table": `Table_tooldb__table__VoJZA`
};
export default ___CSS_LOADER_EXPORT___;
